module.exports = __webpack_public_path__ + "static/img/type3.0a76f5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type3.jpg
// module id = K7BG
// module chunks = 1